export const REQUEST_RECRUITS_SCREENER_DATA= 'REQUEST_RECRUITS_SCREENER_DATA';
export const RECRUITS_SCREENER_DATA_RECEIVED = 'RECRUITS_SCREENER_DATA_RECEIVED';